import { APIContentRequest, APIContentResponse } from '../../../api/types';
import { createApiAction } from '../../../redux/utils/createApiAction';

export const fetchTrainings = createApiAction<APIContentRequest, APIContentResponse>('FETCH_TRAININGS');
